module.exports = __webpack_public_path__ + "AdityaMehta-421b75e9.webp";